import script from "./FDownloadReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./FDownloadReport.vue?vue&type=script&setup=true&lang=ts"

import "./FDownloadReport.vue?vue&type=style&index=0&id=0cbb6d6c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cbb6d6c"]])

export default __exports__